Date.prototype.todayRangeUTC = () => {
  let dt = new Date();
  const tz = `0${(dt.getTimezoneOffset() / 60) | 0}`.slice(-2);
  const from = `${dt.getFullYear()}-${`0${dt.getMonth() + 1}`.slice(-2)}-${`0${dt.getDate()}`.slice(-2)}T${tz}:00:00Z`;
  dt = new Date(dt.getTime() + 86400000);
  const to = `${dt.getFullYear()}-${`0${dt.getMonth() + 1}`.slice(-2)}-${`0${dt.getDate()}`.slice(-2)}T${tz}:00:00Z`;
  return {from, to};
};

Date.prototype.rangeUTC = function() {
  let dt = this;
  const tz = `0${(dt.getTimezoneOffset() / 60) | 0}`.slice(-2);
  const from = `${dt.getFullYear()}-${`0${dt.getMonth() + 1}`.slice(-2)}-${`0${dt.getDate()}`.slice(-2)}T${tz}:00:00Z`;
  dt = new Date(dt.getTime() + 86400000 + 60*60*1000); //extra hour fixes DST edge transition
  const to = `${dt.getFullYear()}-${`0${dt.getMonth() + 1}`.slice(-2)}-${`0${dt.getDate()}`.slice(-2)}T${tz}:00:00Z`;
  return {from, to};
};



// WEBPACK FOOTER //
// ./mixins/date_polyfill.js